import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import {
  MAXIMUM_FILE_UPLOAD_SIZE,
  MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL,
} from 'shared/constants/messages';
import { checkFileSizeLimit } from 'shared/helpers/FileHelper';
import { DirectUpload } from 'activestorage';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
  methods: {
    onFileUpload(file) {
      if (this.isFileUploadDisabled) {
        return Promise.resolve(false);
      }
      if (!file) {
        return Promise.resolve(false);
      }

      this.isUploading = true;

      const uploadPromise = this.globalConfig.directUploadsEnabled
        ? this.onDirectFileUpload(file)
        : this.onIndirectFileUpload(file);

      return Promise.resolve(uploadPromise).finally(() => {
        this.isUploading = false;
      });
    },
    buildFileSizeLimitError(MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE) {
      return this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
        MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
      });
    },
    maximumSupportedFileUploadSize() {
      return this.isATwilioSMSChannel
        ? MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL
        : MAXIMUM_FILE_UPLOAD_SIZE;
    },
    withAlertOnAttachmentFailure(attachFilePromise) {
      return Promise.resolve(attachFilePromise)
        .then(result => result !== false)
        .catch(() => false);
    },
    onDirectFileUpload(file) {
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE =
        this.maximumSupportedFileUploadSize();

      if (!file) {
        return Promise.resolve(false);
      }

      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        const upload = new DirectUpload(
          file.file,
          `/api/v1/accounts/${this.accountId}/conversations/${this.currentChat.id}/direct_uploads`,
          {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          }
        );

        return new Promise(resolve => {
          upload.create((error, blob) => {
            if (error) {
              useAlert(error);
              resolve(false);
            } else {
              resolve(
                this.withAlertOnAttachmentFailure(
                  this.attachFile({ file, blob })
                )
              );
            }
          });
        });
      }

      useAlert(this.buildFileSizeLimitError(MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE));
      return Promise.resolve(false);
    },
    onIndirectFileUpload(file) {
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE =
        this.maximumSupportedFileUploadSize();

      if (!file) {
        return Promise.resolve(false);
      }

      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        return this.withAlertOnAttachmentFailure(this.attachFile({ file }));
      }

      useAlert(this.buildFileSizeLimitError(MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE));
      return Promise.resolve(false);
    },
  },
};
